import "glamor";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUser } from "store/slices/authSlice";
import { MailChimpSubscriptionApi } from "store/slices/salonSlice";
import { usermoduleListViewApi } from "../store/slices/usermoduleSlice";
import { OpenAddClientForm } from "../store/slices/clientSlice";
import { notificationCountApi } from "store/slices/notificationSlice";
import "store/slices/calendarSlice";
import { shouldSubscribeSalonMailchimp } from "./salonSubscription";
import { useSmsAlert } from "./useSmsAlert";

const SalonModule = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const usermodule = useSelector((state) => state.usermodule.isListView);
  const usermoduleApiStatus = useSelector((state) => state.usermodule.isApiStatus);
  useSelector(state => state.salon.isFeatureAccess);
  useSelector(state => state.salon.isActivePlan);
  useSelector(state => state.salon.isSmsAlertData);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const navigate = useNavigate();
  // Navigation is not a retry gesture. Re-requesting an empty menu on every
  // route change re-issued a failing authenticated request (and its
  // "Authenticated API authentication is unavailable." banner) on every tab.
  // A successful empty menu is still a completed load. Re-requesting it on
  // every route change floods the API and can exhaust database connections.
  const menuLoadStatus = usermoduleApiStatus ? usermoduleApiStatus.usermoduleListViewApi : "";
  const canLoadMenu = !menuLoadStatus;

  useEffect(() => {
    dispatch(GetUser());
  }, [dispatch]);

  if (currentUser && currentUser.role_id == 8 && ["/dashboard", "/staff", "/reports"].includes(location && location.pathname)) {
    navigate("/noaccess");
  }

  useEffect(() => {
    if (usermodule.length === 0 && canLoadMenu) {
      dispatch(usermoduleListViewApi()).then((action) => {
        if (action.meta.requestStatus === "fulfilled") {
          //dispatch(salonpermission({ module_id: 6, permissonName: "list" }));
        }
      });
    }
    if (currentUser && currentUser.isOwner === 1) {
      dispatch(notificationCountApi());
      // if ((location && location.pathname === "/dashboard") || (location && location.pathname === "/calendar") || (location && location.pathname === "/settings")) {
      //   // dispatch(GetUser());
      // }
    }else{
      // dispatch(GetUser());
      dispatch(notificationCountApi());
    }
  }, [location, usermodule.length, canLoadMenu]);

  useEffect(() => {
    dispatch(OpenAddClientForm(""));
    if (shouldSubscribeSalonMailchimp(currentUser)) {
      dispatch(MailChimpSubscriptionApi({ id: currentUser.salon.id, salon_id: currentUser.salon.id }));
    }
  }, [location]);

  useSmsAlert(currentUser, auth?.token, dispatch);

};

export { SalonModule };
